import { FaChevronDown, FaChevronRight, FaFileInvoice, FaQrcode, FaRegBell, FaRegUser, FaTicketAlt } from "react-icons/fa";
import { generateBrightColor } from "../../../../utils/Functions";
import { urlHttpGov } from "../../../../services/urls";
import ImagemLogo from './../../../../assets/images/logo.png';
import { ICity } from "../../../../interfaces";

interface IProps {
    primaryColor: string;
    secondaryColor: string;
    darkMode?: boolean;
    fontColor?: string;
    currentRaffleColor?: string;
    nextRaffleColor?: string;
    city?: ICity;
}

const PhoneMockupHome = ({ primaryColor, secondaryColor, darkMode = false, fontColor = "#ffffff", currentRaffleColor = "#254da8", nextRaffleColor = "#079e69", city }: IProps) => {

    const modules = [
        {
            nome: "Importar Notas",
            icone: <FaQrcode style={{ color: fontColor, width: 14, height: 14, margin: "6px 6px" }}/>
        },
        {
            nome: "Minhas Notas",
            icone: <FaFileInvoice style={{ color: fontColor, width: 14, height: 14, margin: "6px 6px" }}/>
        },
        {
            nome: "Meus Bilhetes da Sorte",
            icone: <FaTicketAlt style={{ color: fontColor, width: 14, height: 14, margin: "6px 6px" }}/>
        }
    ]

    const primaryColorBright = generateBrightColor(primaryColor, 0.12);
    const secondaryColorBright = generateBrightColor(secondaryColor, 0.10);
    const currentRaffleColorBright = generateBrightColor(currentRaffleColor, 0.12);
    const nextRaffleColorBright = generateBrightColor(nextRaffleColor, 0.10);


    return (
        <div
            style={{
                width: 300,
                height: 570,
                minWidth: 300,
                borderRadius: 42,
                background: darkMode ? "#292929" : "#F1F3F5",
                overflow: "hidden",
                border: "8px solid #111",
                fontFamily: "system-ui, -apple-system, sans-serif",
                display: "flex",
                flexDirection: "column",
            }}
        >
            {/* HEADER */}
            <div
                style={{
                    background: `linear-gradient(180deg, ${primaryColorBright} 40%, ${primaryColor} 100%)`,
                    padding: "14px 14px 12px",
                    color: fontColor,
                    borderBottomLeftRadius: 20,
                    flexDirection: "column",
                    display: "flex",
                    flex: 1,

                }}
            >
                <div style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                }}>
                    <div style={{
                        textAlign: "start",
                        alignItems: "center",
                        fontSize: 10,
                        fontWeight: 500,
                    }}>
                        <img alt="Logo" src={ImagemLogo} width={'40%'}></img>
                    </div>

                    <div style={{ textAlign: "right", width: '90%', marginRight: 8, lineHeight: 1.1 }}>
                        <div style={{ fontWeight: 600, fontSize: 11 }}>
                            Usuário
                        </div>
                        <div style={{ fontSize: 9, opacity: 0.85 }}>
                            Meu perfil
                        </div>
                    </div>
                    <div style={{ marginRight: 12, borderRadius: 50, width: 30, height: 30, minWidth: 30, minHeight: 30, background: "#f1f1f1", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <FaRegUser style={{ color: "#1d1d1d", width: 16, height: 16 }} />
                    </div>
                    <div
                        style={{
                            position: 'relative',
                            display: 'inline-block',
                            marginTop: 4,
                        }}
                    >
                        <FaRegBell style={{ color: fontColor, fontSize: 22 }} />

                        <div
                            style={{
                                position: 'absolute',
                                top: 2,
                                right: -2,
                                backgroundColor: '#ff4d4f',
                                color: 'white',
                                borderRadius: '50%',
                                minWidth: 9,
                                height: 9,
                                width: 9,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: 7,
                                padding: 5,
                            }}
                        >
                            2
                        </div>
                    </div>
                </div>
                <div style={{ textAlign: "center", marginTop: 6, flexDirection: "row", justifyContent: 'center', gap: 10, display: "flex", alignItems: "center" }}>
                    <img
                        style={{
                            width: 20,
                        }}
                        src={`${urlHttpGov}/logo_county/${city?.logo_light}`}
                        alt='Logo Município'
                    />
                    <div style={{ fontSize: 13, fontWeight: 600 }}>
                        {city?.city} - {city?.uf}
                    </div>
                    <FaChevronDown style={{ color: fontColor, width: 8, height: 8 }} />
                </div>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-around",
                        marginTop: 10,
                    }}
                >
                    <div style={{ textAlign: 'center', lineHeight: 1.2 }}>
                        <div style={{ fontSize: 11 }}>
                            Valor Total
                        </div>
                        <div style={{ fontSize: 11 }}>
                            Fevereiro 2026
                        </div>
                        <div style={{ fontSize: 13, fontWeight: 700 }}>
                            R$ 0,00
                        </div>
                    </div>

                    <div style={{ textAlign: "center", lineHeight: 1.2 }}>
                        <div style={{ fontSize: 11 }}>
                            Total de Bilhetes
                        </div>
                        <div style={{ fontSize: 11 }}>
                            No Sorteio Atual
                        </div>
                        <div style={{ fontSize: 13, fontWeight: 700 }}>
                            0
                        </div>
                    </div>
                </div>
            </div>

            <div style={{ flex: 1, marginTop: 4 }}>
                <div
                    style={{
                        padding: 8,
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: 8,
                        marginBottom: 70
                    }}
                >
                    {modules.map((module, i) => (
                        <div
                            key={i}
                            style={{
                                background: darkMode ? "#4b4a4a" : "#ffffff",
                                borderRadius: 8,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                boxShadow: "0 3px 8px rgba(0,0,0,0.05)",
                                padding: "2px 2px",
                                minHeight: 50,
                            }}
                        >
                            <div
                                style={{
                                    width: 26,
                                    height: 26,
                                    minWidth: 26,
                                    minHeight: 26,
                                    borderRadius: 4,
                                    background: `linear-gradient(180deg, ${primaryColorBright} 40%, ${primaryColor} 100%)`,
                                    marginLeft: 6,
                                }}
                            >
                                {module.icone}
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: 6, padding: 2 }}>

                                <div style={{ fontWeight: 700, fontSize: 10, textAlign: 'center', color: darkMode ? "#EDEDED" : "#111" }}>
                                    {module.nome}
                                </div>
                            </div>
                            <div
                                style={{
                                    fontSize: 10,
                                    fontWeight: 600,
                                    marginRight: 2,
                                    marginTop: 4,
                                }}
                            >
                                <FaChevronRight style={{ color: primaryColor }} />
                            </div>
                        </div>
                    ))}
                </div>

                <div
                    style={{
                        marginTop: 0,
                        background: `linear-gradient(180deg, ${secondaryColorBright} 0%, ${primaryColor} 70%)`,
                        padding: "6px 16px 18px",
                        borderTopLeftRadius: 18,
                        color: fontColor,
                        fontSize: 16,
                        fontWeight: 600,
                    }}
                >
                    Sorteios
                </div>
                <div
                    style={{
                        background: darkMode ? "#292929" : "#F1F3F5",
                        padding: 16,
                        borderTopLeftRadius: 30,
                        top: -14,
                        left: -4,
                        width: "calc(100% + 12px)",
                        position: "relative",
                        display: "flex",
                        gap: 16,
                    }}
                >
                    <div
                        style={{
                            flex: 1,
                            background: `linear-gradient(180deg, ${currentRaffleColorBright} 40%, ${currentRaffleColor} 100%)`,
                            borderRadius: 16,
                            padding: 10,
                            color: fontColor,
                            textAlign: "center",
                        }}
                    >
                        <div style={{ fontWeight: 700, fontSize: 14 }}>
                            3º Sorteio
                        </div>
                        <div style={{ marginTop: 18, fontSize: 12 }}>
                            Período Atual
                        </div>
                        <div style={{ marginTop: 20, fontWeight: 700 }}>
                            Nº 3
                        </div>
                        <div style={{ fontSize: 15 }}>
                            21/12/2025
                        </div>
                    </div>
                    <div
                        style={{
                            flex: 1,
                            background: `linear-gradient(180deg, ${nextRaffleColorBright} 40%, ${nextRaffleColor} 100%)`,
                            borderRadius: 16,
                            padding: 10,
                            color: fontColor,
                            textAlign: "center",
                        }}
                    >
                        <div style={{ fontWeight: 700, fontSize: 14 }}>
                            Sorteio IPTU
                        </div>
                        <div style={{ marginTop: 18, fontSize: 12 }}>
                            Próximo sorteio
                        </div>
                        <div style={{ marginTop: 20, fontWeight: 700 }}>
                            IPTU
                        </div>
                        <div style={{ fontSize: 15 }}>
                            21/12/2025
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PhoneMockupHome;